import init_reveal from './_reveal';

(function() {
    let camera, scene, renderer, cylinder, texture;

    init();
    animate();

    function init() {
        renderer = new THREE.WebGLRenderer();
        renderer.setSize(window.innerWidth, window.innerHeight);

        let main = document.getElementsByTagName('main')[0];

        main.prepend(renderer.domElement);

        scene = new THREE.Scene();
        camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 0.1, 10000);
        camera.position.set(0, 0, 7);
        camera.lookAt(scene.position);
        scene.add(camera);

        var light = new THREE.PointLight(0x8C92A5ff, 10, 25);
        light.position.set(0, -3, 0);
        scene.add(light);

        var light = new THREE.PointLight(0x3D478Aff, 15, 30);
        light.position.set(3, 3, 0);
        scene.add(light);

        scene.fog = new THREE.FogExp2(0x000000, 0.15);
        THREE.TextureLoader.prototype.crossOrigin = '';
        texture = new THREE.TextureLoader().load("https://threejs.org/examples/textures/water.jpg");
        texture.wrapT = THREE.RepeatWrapping;
        texture.wrapS = THREE.RepeatWrapping;

        var material = new THREE.MeshLambertMaterial({
            color: 0xffffff,
            opacity: 1,
            map: texture
        });
        var cylinder_geometry = new THREE.CylinderGeometry(1, 1, 30, 32, 1, true);

        cylinder = new THREE.Mesh(cylinder_geometry, material);
        material.side = THREE.BackSide;
        cylinder.rotation.x = Math.PI / 2;
        scene.add(cylinder);

        window.addEventListener('resize', function() {
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(window.innerWidth, window.innerHeight);
        }, false);

        init_reveal();
    }

    function animate() {
        requestAnimationFrame(animate);
        render();
    }

    function render() {
        cylinder.scale.set(1, 1, 1);
        texture.offset.y -= 0.0008 * 8;
        texture.offset.y %= 1;
        texture.needsUpdate = true;

        camera.rotation.z = 0.2 * (Date.now() / 1000);
        renderer.render(scene, camera);
    }
})();